import Vue from "vue";
import { errorServeiceHandler, makeQueryStringDync, makeQueryFormDataDyn } from "../../helper";

const state = {
  editDetails: undefined
};

const getters = {
  getEditDetails: (state) => {
    return state.editDetails;
  }
};

const mutations = {
  setEditDetails: (state, data) => {
    state.editDetails = data;
  }
};

const actions = {
  getHardwareAndLco: context => {
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/cpe", {
        method: "GET"
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve();
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve();
          }
          console.log("error", error);
          reject(error);
        });
    });
  },
  actPutProfileDetails: (context, payload) => {
    return new Promise((resolve, reject) => {


      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      var object = {};
      data.forEach(function (value, key) {
        object[key] = value;
      });
      data = JSON.stringify(object);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber", {
        method: "PUT",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve();
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve();
          }
          console.log("error", error);
          reject(error);
        });
    });
  },
  actPostChangePassword: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);

      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/changepassword", {
        method: "POST",
        body: data
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve();
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve();
          }
          console.log("error", error);
          reject(error);
        });
    });
  }
};

export default {
  actions, state, getters, mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/myprofile/details.js